import * as colors from "common/colors";
import * as numbers from "common/numbers";

export const makeLossDevelopmentHeatmapColourizer = (
  lossDevelopment,
  accentColor
) => {
  const losses = lossDevelopment?.losses;
  if (!losses || losses.length < 4) {
    return () => null;
  }

  const premiumByPolicyYear = Object.fromEntries(
    lossDevelopment?.premiumByPolicyYear?.map(({ value, inception }) => [
      inception,
      value,
    ]) ?? []
  );

  const lossRatios = losses
    .map(({ value, inception }) => value / premiumByPolicyYear[inception])
    .filter(Number.isFinite);

  return makeLossRatioHeatmapColourizer(lossRatios, accentColor);
};

export const makeLossRatioHeatmapColourizer = (lossRatios, accentColor) => {
  if (!lossRatios || lossRatios?.length < 4) {
    return () => null;
  }

  const boundaryValues = numbers.quantiles(lossRatios, lossRatios.length);
  const palette = colors.shades("#ffffff", accentColor, lossRatios.length);

  return (value) => {
    if (!boundaryValues || value == null) {
      return null;
    }

    for (let i = 0; i < boundaryValues.length; i++) {
      if (value <= boundaryValues[i]) {
        return palette[i];
      }
    }

    return palette[palette.length - 1];
  };
};
